<template>
  <div class="curse">
    <headerNav :isindex="false" :canclick="false" :islist="true" :header-title="webName" :show-sort="showSort" @yinYang="yinYang" />
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getMoreDatas">
      <div style="height:44px;"></div>
      <div v-for="(item,index) in datalist" :key="index" class="listsBox" @click="goDetail(item.lesson_id)">
        <div class="leftBox">
          <!-- <div v-show="item.tag" class="tag">
            {{ item.tag }}
          </div> -->
          <img class="thumb" :src="item.thumb + img_base" alt>
        </div>
        <div class="rightCxt">
          <div class="lessonName">
            <p>{{ item.lesson_name }}</p>
          </div>
          <div class="infoNum">
            <img class="student_icon" src="@/assets/img/team.png" alt="">
            <span class="student_counts">{{ showStudents(item.student_count) }}人学习</span>
            <img class="rate_icon" src="@/assets/img/haoping.png" alt="">
            <span class="rate_num">{{ parseInt(item.comment_rate) }}%好评</span>
          </div>
          <!-- <div class="lessonPrice">
            <span v-if="!(code_type && code_type ==1)">￥{{ item.price.toFixed(2) }}</span>
          </div> -->
        </div>
      </div>
    </van-list>
    <footerNav :actived="0"></footerNav>
  </div>
</template>
<script>
import { getLessonList } from '@/api/course.js'
import '@/assets/fg.css'
import tool from '@/utils/tools.js'
import Cookies from 'js-cookie'
import WechatState from '@/utils/isWechatState.js'

export default {
  data() {
    return {
      img_base: '?x-oss-process=image/resize,m_fill,w_424,h_320',
      loading: false,
      finished: false,
      isShow: true,
      total: 0,
      limit: 10,
      page: 1,
      datalist: [],
      currentIndex: 0,
      code_type: '',
      webName: Cookies.get('webName') || '',
      showSort: Cookies.get('webName') ? '0' : '1',
      category_id:''
    }
  },
  watch: {
    msg(newValue, oldValue) {
      console.log('监听到变化')
      this.beforeOnLoad()
    },
    downloadShow() {
      var noy = document.getElementsByClassName('van-tabs__wrap')[0]
      if (!tool.isInApp()) {
        if (this.downloadShow) {
          noy.style = 'top: auto'
        } else {
          noy.style = 'margin-top: -50px'
        }
      }
    }
  },
  created() {
    this.getCurrentPage()

    this.beforeOnLoad()
  },
  mounted() {
  },
  methods: {
    yinYang(value) {
      this.page=1
      this.datalist=[]
      this.webName = value.className
      this.category_id = value.firstId
      this.beforeOnLoad()
    },
    beforeOnLoad() {
      // 注意顺序
      this.datalist = []
      this.finished = false
      this.page = this.getCurrentPage()
      this.onLoad()
    },
    onLoad() {
      this.loading = true
      this.page = this.getCurrentPage()
      console.log('page is ' + this.page)
      const params = {
        pageNum: this.page,
        pageSize: this.limit,
        type:0,
        category_id: this.category_id
      }
      getLessonList(params).then(res => {
        this.loading = false
        const result = res.result ? res.result : {}
        const list = result.list ? result.list : []
        this.code_type = result.code_type || 0
        this.total = result.count
        if (this.page === 1) {
          this.datalist = list
        } else {
          this.datalist = this.datalist.concat(list)
        }
        // 是否 有值显示
        if (this.datalist.length > 0) {
          this.isShow = true
        } else {
          this.isShow = false
        }
        // 是否结束
        if (list.length < this.limit) {
          this.finished = true
          console.log('没有更多了')
        } else {
          this.finished = false
        }
      })
    },
    getMoreDatas() {
      this.onLoad()
    },
    getCurrentPage() {
      const count = this.datalist.length
      const limit = this.limit
      const page = Math.ceil((count / limit)) + 1 // 默认1
      return page
    },
    goDetail(id) {
      const mplogin = WechatState.checkWechatMPLogin()
      if (!mplogin) return

      // 跳转课程详情页
      if (tool.isInApp()) {
        const url = window.location.href + 'd/' + id + '.html'
        console.log(url, 'url')
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_openLesson.postMessage(url)
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_openLesson'
            , url
            , function(responseData) {
              // android 返参数接受
            }
          )
        }
      } else {
        this.$router.push({
          path: '/details/course',
          query: {
            lesson_id: id
          }
        })
      }
    },
    showStudents(num) {
      if (num > 10000) {
        const value = parseFloat(num / 10000.0).toFixed(1)
        const str = String(value) + 'w'
        return str
      } else {
        return num
      }
    }
  }
}
</script>
<style scoped lang='scss'>
/deep/ .van-tabs__wrap {
  position: fixed;
  top: 80px;
  width: 100%;
  z-index: 999;
}
.curse {
  width: 100%;
  // .top {
  //   margin-top: 78px;
  //   padding-bottom: 100px;
  // }
  .top1 {
    margin-top: 0px;
  }
}
// vant组件库样式修改
.van-tabs /deep/ .van-tabs__wrap {
  border-bottom: 1px solid #eee;
  margin-bottom: 10 0 13px auto;
}
.van-pull-refresh {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.van-icon /deep/ .van-icon::before {
  margin-right: 11px;
}
/deep/.van-tabs__line {
  border-radius: 0;
}
/deep/.van-tab .van-tab__text {
  font-size: 28px;
  color: #333;
  padding-top: 6px;
}
/deep/.van-tab--active .van-tab__text {
  font-size: 28px;
  color: #ee2e2e;
}
.listsBox {
  margin: 25px 20px 0px 20px;
  padding-bottom: 20px;
  width: calc(100% - 40px);
  display: flex;
  flex-direction: row;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}
.leftBox {
  width: 240px;
  display: flex;
  // flex-direction: column;
  .thumb {
    width: 240px;
    height: 155px;
    border-radius: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tag {
    position: absolute;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 10px 0px 10px 0;
    font-size: 24px;
    color: #866335;
    background-image: linear-gradient(to right, #fceacc, #f6d19d);
  }
}
.rightCxt {
  margin-left: 15px;
  width: calc(100% - 255px);
  // display: flex;
  // flex-direction: column;
  .lessonName {
    font-size: 30px;
    color: #333;
    min-height: 60px;
    line-height: 38px;
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .infoNum {
    margin-top: 10px;
    display: flex;
    align-items: center;
    .student_icon {
      width: 30px;
      height: 24px;
    }
    .student_counts {
      margin-left: 8px;
      color: #999;
      font-size: 24px;
    }
    .rate_icon {
      margin-left: 20px;
      width: 26px;
      height: 30px;
    }
    .rate_num {
      margin-left: 8px;
      color: #999;
      font-size: 24px;
    }
  }
  .lessonPrice {
    margin-top: 10px;
    margin-bottom: 25px;
    color: #ee2e2e;
    font-size: 28px;
  }
}
</style>
